import axios from "axios";
import store from "@/store/index";
import UserService from "@/services/UserService";
import router from "@/router/index";
// const CancelToken = axios.CancelToken;

// Save Requests Cancel Token, To Cancel If Repeat Req Same Url
const instanceAxios = axios.create({ timeout: 60000, requests: [] });
instanceAxios.defaults.baseURL = process.env.API_URL;

instanceAxios.interceptors.request.use(
  (config) => {
    const user = store.state.Root.user;
    if (user.token) {
      config.headers["Authorization"] = "Bearer " + user.token;
    }
    //     /** In dev, intercepts request and logs it into console for dev */
    //     if (config.requests[config.url] !== undefined) {
    //       config.requests[config.url]("Cancel repeated request"); // cancel request
    //     }
    //     // config.cancelToken= new CancelToken((cancel) => cancel('Cancel repeated request'))

    //     config.cancelToken = new CancelToken(function executor(c) {
    //       // console.log("Cancelled", c);
    //       //Get Cancel Function, To Create Cancel Request
    //       config.requests[config.url] = c;
    //     });
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    return config;
  }

  //   error => {
  //     if (error) {
  //       let status;
  //       let data;
  //       if (error.response) {
  //         // The request was made and the server responded with a status code
  //         // that falls out of the range of 2xx
  //         data = error.response.data;
  //         status = error.response.status;
  //       }
  //       if (error.code === "ECONNABORTED" || status === 408 || status === 504) {
  //         store.dispatch("setStatusMsg", "Error: The server isn't responding. Please try again.");
  //         //do something. Try again perhaps?
  //       } else {
  //         store.dispatch("setStatusMsg", "Error: Something has gone wrong. Please try again.");
  //       }
  //     }
  //     return Promise.reject(error);
  //   }
);

instanceAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error) {
      let status;
      // let data;
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // data = error.response.data;
        status = error.response.status;
      }
      if (error.code === "ECONNABORTED" || status === 408 || status === 504) {
        //TODO do something. Try again perhaps?
      } else if (status === 401) {
        UserService.logOut();
      } else if (status === 503) {
        store.dispatch("Root/setUnderMaintenance", true);
        router.push({ name: "maintenance" });
      } else {
        //TODO
      }
    }
    return Promise.reject(error);
  }
);

export default instanceAxios;
